import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHeart, FiFacebook, FiLinkedin, FiInstagram, FiMessageCircle } = FiIcons;

const Footer = () => {
  const quickLinks = [
    { name: 'How It Works', href: '#how-it-works' },
    { name: 'Results', href: '#results' },
    { name: 'FAQ', href: '#faq' },
    { name: 'About Sanna', href: '#guarantee' },
  ];

  const legalLinks = [
    { name: 'Terms of Service', href: '#' },
    { name: 'Privacy Policy', href: '#' },
    { name: 'Accessibility', href: '#' },
  ];

  const socialLinks = [
    { name: 'Facebook', icon: FiFacebook, href: 'https://Facebook.com/337098602826472' },
    { name: 'LinkedIn', icon: FiLinkedin, href: 'https://www.linkedin.com/in/sanna-darwish-m-s-ccc-slp-b2a3491a8' },
    { name: 'Instagram', icon: FiInstagram, href: 'https://www.instagram.com/wethebillions' },
    { name: 'WhatsApp', icon: FiMessageCircle, href: 'https://wa.me/+12026560054' },
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <div>
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753170072528-v%20lg%20We%20The%20Billions%20logo.png"
                alt="We The Billions"
                className="h-12 w-auto mb-4"
              />
              <p className="text-gray-300 leading-relaxed">
                86 billion neurons. 1 unique YOU.
              </p>
            </div>
            <div className="space-y-2 text-sm text-gray-400">
              <p>Virtual & In-Person Sessions</p>
              <p>(MD & VA)</p>
              <p className="mt-4">www.wethebillions.com</p>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-300">
              <span>Made with</span>
              <SafeIcon icon={FiHeart} className="h-4 w-4 text-red-400" />
              <span>for every unique brain</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-6">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href.replace('#', ''))}
                    className="text-gray-300 hover:text-accent-gold transition-colors duration-200"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href="https://www.wethebillions.com/quiz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-accent-gold transition-colors duration-200"
                >
                  Take Quiz
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-6">
              Contact
            </h3>
            <div className="space-y-3 text-gray-300">
              <p>
                <a
                  href="mailto:hello@wethebillions.com"
                  className="hover:text-accent-gold transition-colors duration-200"
                >
                  hello@wethebillions.com
                </a>
              </p>
              <p>
                <a
                  href="tel:+12026560054"
                  className="hover:text-accent-gold transition-colors duration-200"
                >
                  (202) 656-0054
                </a>
              </p>
              <p>
                <a
                  href="https://wethebillions.neetocal.com/consultation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent-gold transition-colors duration-200"
                >
                  Book Online
                </a>
              </p>
            </div>
          </div>

          {/* Social & Legal */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-6">
              Follow Us
            </h3>
            <div className="flex gap-4 mb-8">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-accent-magenta transition-colors duration-200"
                  aria-label={social.name}
                >
                  <SafeIcon icon={social.icon} className="h-5 w-5" />
                </a>
              ))}
            </div>
            <div className="space-y-2">
              {legalLinks.map((link, index) => (
                <div key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-accent-gold transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753416293845-4.png"
                alt="Brain Icon"
                className="h-8 w-8"
              />
              <p className="text-sm text-gray-400">
                © 2024 We The Billions. All rights reserved.
              </p>
            </div>
            <p className="text-sm text-gray-400">
              Elite Performance Cognitive Training
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;